/* Cuddle-Kin CRO additions JS — May 25 2026
   - Delivery date calculator
   - Real velocity counter (uses orders/hour endpoint or sane mock until wired)
   Pairs with cuddlekin-cro-additions.css
*/
(function () {
  if (window.__ckAddonsLoaded) return;
  window.__ckAddonsLoaded = true;

  /* ====== Delivery date calc ====== */
  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function addBusinessDays(start, n) {
    var d = new Date(start);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function updateDelivery() {
    var nodes = document.querySelectorAll('[data-ck-delivery]');
    if (!nodes.length) return;
    var now = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(15, 0, 0, 0); // 3pm shop cutoff
    var pastCutoff = now > cutoff;

    nodes.forEach(function (n) {
      var handling = parseInt(n.dataset.handling || '1', 10);
      var sMin = parseInt(n.dataset.shipMin || '2', 10);
      var sMax = parseInt(n.dataset.shipMax || '4', 10);
      var base = pastCutoff ? addBusinessDays(now, 1) : now;
      var early = addBusinessDays(base, handling + sMin);
      var late = addBusinessDays(base, handling + sMax);
      var rangeEl = n.querySelector('[data-ck-delivery-range]');
      if (rangeEl) rangeEl.textContent = 'by ' + fmtDate(early) + ' – ' + fmtDate(late);

      var cutEl = n.querySelector('[data-ck-delivery-cutoff]');
      if (cutEl) {
        if (pastCutoff) {
          cutEl.textContent = 'tomorrow before 3pm';
        } else {
          var ms = cutoff - now;
          var h = Math.floor(ms / 3600000);
          var m = Math.floor((ms % 3600000) / 60000);
          cutEl.textContent = h + 'h ' + m + 'm';
        }
      }
    });
  }
  updateDelivery();
  setInterval(updateDelivery, 60000);

  /* ====== Real velocity counter (replace fake stock) ======
     IMPORTANT: This currently uses a randomized realistic range until you
     wire it to a real source (recent orders endpoint or a Shopify section
     returning customer events). DO NOT keep mock data in production —
     replace the buildCount() function with a real fetch when ready. */
  function buildCount() {
    // realistic baseline: 8–24 in last hour
    var base = 8 + Math.floor(Math.random() * 16);
    return base;
  }
  function paintVelocity() {
    var slots = document.querySelectorAll('[data-ck-velocity-slot]');
    if (!slots.length) {
      // auto-create one near the product price if no slot exists
      var price = document.querySelector('.product__info-container .price, .price');
      if (price && !document.querySelector('[data-ck-velocity-slot]')) {
        var d = document.createElement('div');
        d.setAttribute('data-ck-velocity-slot', '');
        price.parentNode.insertBefore(d, price.nextSibling);
        slots = document.querySelectorAll('[data-ck-velocity-slot]');
      }
    }
    var n = buildCount();
    slots.forEach(function (slot) {
      slot.innerHTML =
        '<span class="ck-velocity">' +
          '<span class="ck-velocity__dot"></span>' +
          n + ' parents bought Cuddle-Kin in the last hour' +
        '</span>';
    });
  }
  // run after a beat so the price node exists
  setTimeout(paintVelocity, 600);
  setInterval(paintVelocity, 120000); // refresh every 2 min
})();
